

















import { Component, Vue } from 'vue-property-decorator';
import { sendLog } from '@/api/client-logs';
import PageHeaderError from '@/components/PageHeaderError.vue';
import FooterButton from '@/components/FooterButton.vue';

@Component({
  components: {
    PageHeaderError,
    FooterButton
  }
})
export default class Page extends Vue {
  private isRedirected: boolean = false;
  private timerId: number = -1;

  private get messages(): string[] {
    const key: string = `componentsUnsupportView.redirect.message`;
    return (this.$t(key) as { [key: number]: string }) as string[];
  }

  private get redirectURL(): string {
    const kycRequestErrorRedirectURL: string = this.$store.getters['auth/kycRequestErrorRedirectURL'] || '';
    if (kycRequestErrorRedirectURL.match(/^\s*javascript:/) !== null) return '';
    return kycRequestErrorRedirectURL;
  }

  private get isAutoRedirect(): boolean {
    if (!this.redirectURL) return false;
    return true;
  }

  async mounted(): Promise<void> {
    if (this.isAutoRedirect) {
      this.timerId = window.setTimeout((): void => {
        this.redirect(true);
      }, 1000);
    }
  }

  beforeDestroy(): void {
    window.clearTimeout(this.timerId);
  }

  private async redirect(isAutomaticPageTransition: boolean): Promise<void> {
    if (this.isRedirected) return;
    this.isRedirected = true;

    let err: number = 0;
    if (!this.$store.getters['support/isCamera']) err = 3;
    if (!this.$store.getters['support/isBrowser']) err = 2;
    if (!this.$store.getters['support/isOS']) err = 1;
    const match: RegExpMatchArray | null = this.redirectURL.match(/^([^?#]*)(\?[^#]*)?(#.*)?$/);
    if (match === null) return;
    const query: string = `${match[2] ? `${match[2]}&` : '?'}err=${err}`;
    const hash: string = match[3] || '';
    const redirectURL: string = `${match[1]}${query}${hash}`;

    // リダイレクト直前にログを送信
    const isLogSuccess: boolean = await sendLog({
      level: 'INFO',
      kind: 'debug_log',
      fields: [isAutomaticPageTransition ? 'timeout' : 'button'],
      message: 'unsupport redirect'
    });

    // ログ送信が完了して一定時間経過したらボタンを再び押せるようにする
    window.clearTimeout(this.timerId);
    this.timerId = window.setTimeout((): void => {
      this.isRedirected = false;
    }, 1000);

    // ログ送信に成功したらページ遷移
    if (isLogSuccess) window.location.href = redirectURL;
  }

  private onNext(): void {
    this.redirect(false);
  }
}
